import { createFileRoute } from "@tanstack/react-router";
import IrrigationSystems from "@/components/field/setup/IrrigationSystems";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/irrigation-system/",
)({
    component: IrrigationSystemsPane,
});

function IrrigationSystemsPane() {
    return <IrrigationSystems />;
}
